import React, {useEffect, useState} from 'react'
import Button from "@material-ui/core/Button";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import {useSnackbar} from "notistack";
import CardMedia from "@material-ui/core/CardMedia";
import Card from "@material-ui/core/Card";

const UploadFileProperties = ({setImageContent}) => {
    return (
        <div>
            <UploadButton
                setImageContent={setImageContent}
            />
            <UploadFromClipBoard
                setImageContent={setImageContent}
            />
        </div>
    )
};
export default UploadFileProperties;

//upload file from button component
const UploadButton = ({setImageContent}) => {
    const [file, setFile] = useState({});
    return (
        <>
            <input id="uploadFile"
                   type="file"
                   name='uploadFile'
                   onChange={(e) => fileUpload(e, setFile, setImageContent, '.properties.publicUrl')}
                   style={{
                       width: '0.1px',
                       height: '0.1px',
                       opacity: 0,
                       overflow: 'hidden',
                       position: 'absolute',
                       zIndex: -1
                   }}
            />
            <label htmlFor="uploadFile">
                <Button variant={'contained'}
                        style={{margin: '5px 5px 5px 0'}}
                        size={"small"}
                        color={"primary"}
                        component="span">
                    Upload
                </Button>
                <span>{file.name}</span>
            </label>
        </>
    )
};

//upload file from clipboard component
const UploadFromClipBoard = ({setImageContent}) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <Button
                onClick={() => setOpen(true)} variant={"contained"} color={"primary"} size={"small"}>
                From clipboard
            </Button>
            <ClipboardZone
                onClose={() => setOpen(false)}
                open={open}
                setResult={(result) => setImageContent(result)}
            />
        </>
    )
};
const ClipboardZone = ({open, onClose, setResult}) => {
    const {enqueueSnackbar} = useSnackbar();
    const [image, setImage] = useState({base64: ""});
    const handler = (e) => clipboardHandler(e, enqueueSnackbar, setImage);
    useEffect(() => {
        if (open) {
            window.addEventListener('paste', handler, false);
        }
        return () => {
            window.removeEventListener('paste', handler, false)
        }
    });
    return (
        <Dialog
            id={"clipboard_paste"}
            open={open}
            onClose={() => {
                onClose();
                window.removeEventListener('paste', handler, false)
            }}
            maxWidth={"xl"}
            fullWidth={true}
            //         onEntered={() => initClipboardListener(handler)}
            //     onExited={() => removeClipboardListener(handler)}
        >
            <DialogTitle style={{padding: '8px 12px'}}>
                Add picture from clipboard <small>(Use PrintScreen key and then Ctrl+V.)</small>
            </DialogTitle>
            <Divider/>
            <DialogContent style={{height: '94vh'}}>
                <Card style={{display: 'table'}}>
                    <CardMedia
                        image={image.base64}
                        component="img"
                    />
                </Card>
            </DialogContent>
            <Divider/>
            <DialogActions>
                <Button
                    variant={"contained"}
                    color={"primary"}
                    size={"small"}
                    onClick={() => {
                        setResult(image);
                        onClose()
                    }}
                >
                    Apply
                </Button>
                <Button
                    variant={"contained"}
                    color={"default"}
                    size={"small"}
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
};


//button upload managing
export function fileUpload(e, setFile, setImageContent, pathToProps) {
    let files = e.target.files;
    for (let i = 0; i < files.length; i++) {
        let file = files[i];
        // Make new FileReader
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        // on reader load something...
        reader.onload = () => {
            // Make a fileInfo Object
            setFile({
                name: file.name,
                type: 'screenImage',
                refEntity: 'screen',
                base64: reader.result,
            });
            setImageContent({
                name: file.name,
                type: file.type,
                base64: reader.result,
                pathToProps
            })
        }
    }
}

//clipboard managing
function clipboardHandler(e, enqueueSnackbar, setImage) {
    let items = e.clipboardData.items;
    if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                let blob = items[i].getAsFile();
                let reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = () => {
                    setImage(
                        {
                            name: blob.name,
                            type: blob.type,
                            base64: reader.result,
                        })
                };
                return
            }
        }
        //return err , that no image in clipboard
        enqueueSnackbar('No image in clipboard', {variant: 'error'})
    } else {
        enqueueSnackbar('No image in clipboard', {variant: 'error'});
    }
}